import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import PeopleIcon from '@mui/icons-material/People';
import SpeedIcon from '@mui/icons-material/Speed';

interface StatCardProps {
  icon: 'vehicle' | 'member' | 'mileage';
  value: string | number;
  label: string;
}

/**
 * Composant pour afficher une carte de statistique avec une icône, une valeur et une étiquette
 */
const StatCard: React.FC<StatCardProps> = ({ icon, value, label }) => {
  const getIcon = () => {
    switch (icon) {
      case 'vehicle':
        return <DirectionsCarIcon sx={{ fontSize: 40, color: '#1976d2' }} />;
      case 'member':
        return <PeopleIcon sx={{ fontSize: 40, color: '#1976d2' }} />;
      case 'mileage':
        return <SpeedIcon sx={{ fontSize: 40, color: '#1976d2' }} />;
      default:
        return null;
    }
  };

  return (
    <Paper
      sx={{
        p: 3,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 2,
        boxShadow: 3,
      }}
      elevation={1}
    >
      <Box sx={{ mb: 2 }}>{getIcon()}</Box>
      <Typography variant="h4" component="div" gutterBottom>
        {value}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Paper>
  );
};

export default StatCard;